/* eslint-disable react/jsx-fragments */
import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { CordProvider } from '@cord-sdk/react';
import NotificationsContainer from '@saucelabs/sl-container-notifications';
import ErrorPagesContainer from '@saucelabs/sl-container-error-pages';
import { useFlags } from '@saucelabs/sl-util-launchdarkly';
import { records as userRecords } from '@saucelabs/sl-module-user';
import { profitwellApiTokenRow } from '@saucelabs/sl-util-config';

import Styles from './ApplicationContainer.styles';
import CreditRefreshModalContainer from '../../credit-refresh-modal/containers/CreditRefreshModalContainer';
import { DarkMode } from '../../dark-mode/DarkMode';
import ProfitwellHelper from '../components/ProfitwellHelper';

const ErrorPagesWithRouter = withRouter(ErrorPagesContainer);
const ApplicationContent = ({
  children,
  cordAuthToken,
  user,
}) => {
  const flags = useFlags();

  return (
    <div className={Styles.content}>
      <Helmet
        defaultTitle="Sauce Labs"
        titleTemplate="%s | Sauce Labs"
      />
      <NotificationsContainer />
      <ErrorPagesWithRouter>
        <CreditRefreshModalContainer />
        {flags?.growthCord ? (
          <CordProvider clientAuthToken={cordAuthToken}>
            {children}
          </CordProvider>
        ) : children}
        <DarkMode />
        {profitwellApiTokenRow && (
          <ProfitwellHelper
            profitwellApiTokenRow={profitwellApiTokenRow}
            user={user}
          />
        )}
      </ErrorPagesWithRouter>
    </div>
  );
};

ApplicationContent.propTypes = {
  children: PropTypes.node.isRequired,
  cordAuthToken: PropTypes.string,
  user: ImmutablePropTypes.recordOf(userRecords.UserRecordClass),
};

ApplicationContent.defaultProps = {
  cordAuthToken: undefined,
  user: undefined,
};

export default ApplicationContent;
export { ApplicationContent };
